import React from "react";

export function formatUSPhoneNumber(number) {
  const cleaned = ("" + number).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]} ${match[3]}`;
  }

  return number;
}

export const formatDate = (dateString) => {
  let isoString;
  if (dateString?.includes("T")) {
    isoString = dateString;
  } else {
    isoString = dateString.replace(" ", "T") + "Z";
  }

  const date = new Date(isoString);
  //   if (!dateString) return "--";
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    timeZone: "UTC", // <-- change to EST or any timezone
  }).format(date);
};

export const formatDateTime = (dateString) => {
  let isoString;
  if (dateString?.includes("T")) {
    isoString = dateString;
  } else {
    isoString = dateString.replace(" ", "T") + "Z";
  }

  const date = new Date(isoString);
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    // second: "2-digit",
    hour12: true,
    timeZone: "UTC", // <-- change to EST or any timezone
  }).format(date);
};

export function timeToSeconds(timeStr) {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function secondsToHMS(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  // pad with leading zeros if needed
  const hh = String(h).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

export function formatDateTimeNew(dateString) {
  if (!dateString) return "--";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });
}

export function formatDateTimeShort(dateString) {
  if (!dateString) return "--";
  const date = new Date(dateString);

  const datePart = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    timeZone: "UTC",
  });

  const timePart = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });

  return `${datePart}<br />${timePart}`;
}
